var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
var StyledSelect = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%;\n  box-sizing: border-box;\n"])));
export var HiddenSelect = forwardRef(function (_a, ref) {
    var onChange = _a.onChange;
    return React.createElement(StyledSelect, { "aria-hidden": true, tabIndex: -1, ref: ref, onChange: onChange });
});
var templateObject_1;
//# sourceMappingURL=hiddenselect.component.js.map